
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Template } from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { TagService } from "@/script/apps/cms/service/TagService";
import { ElMessage } from "element-plus";
import { TemplateService } from "@/script/apps/cms/service/TemplateService";
import TemplateRefer from "./TemplateRefer.vue";

@Options({
  components: { TemplateRefer },
})
export default class TemplateDetail extends BaseDetail {
  private service = new TemplateService();
  private content = "";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_template",
      "/cms/template",
      "/cms/template",
      this.service
    );
    data.typesName = "template-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    path: [{ required: true, message: "请输入路径", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
  };

  public newEntity() {
    const entity: Template = { mainTemplate: { name: "" } };
    this.content = "";
    return entity;
  }

  public afterLoad(data: any) {
    const template = data as Template;
    this.content = "";
    this.service.loadContent(template.id!).then(
      (result: any) => {
        this.content = result.data;
      },
      (error: Error) => {        
        ElMessage.error("读取内容失败，失败原因：" + error.message);
      }
    );

    if (!template.mainTemplate) {
      template.mainTemplate = { name: "" };
    }
    if (template.mainTemplateId) {
      this.serviceContext.service.loadEntity(
        this.serviceContext.serviceData.loadApiName,
        {
          id: template.mainTemplateId!,
        },
        (data: any) => {
          template.mainTemplate = data;
        }
      );
    }
  }

  private selectTemplate() {
    (this.$refs.templateRefer as TemplateRefer).show((data: Template) => {
      const template = this.entity as Template;
      template.mainTemplateId = data.id;
      template.mainTemplate!.name = data.name;
    });
  }

  public save() {
    const self = this;
    (this.$refs.mainForm as any).validate((valid: boolean) => {
      if (valid) {
        if (!self.beforeSave()) {
          return;
        }
        self.serviceContext.service.saveEntity(
          self.serviceContext.serviceData.saveApiName,
          self.entity,
          function (data: any) {
            self.id = data.id;
            self.entity.id = data.id;
            ElMessage({ type: "success", message: "保存成功!" });

            self.service.saveContent(self.entity.id!, self.content).then(
              (result: any) => {
                self.load(self.id);
              },
              (error: Error) => {
                ElMessage.error("保存内容失败，失败原因：" + error.message);
              }
            );
          },
          function (error: Error) {
            ElMessage.error("保存失败，原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
